<template>
  <showForm
  :formsesid = "formsid"
  :requiredsubmit = 'false'
  closedoption = "epro"
  :isfieldvalidate = "showpopup"
        type: Boolean,
        default: false
   />
</template>

<script src="./showformwithdataComponent.js"></script>
